import { render, staticRenderFns } from "./edit-icon.vue?vue&type=template&id=5990ab41&scoped=true"
import script from "./edit-icon.vue?vue&type=script&lang=js"
export * from "./edit-icon.vue?vue&type=script&lang=js"
import style0 from "./edit-icon.vue?vue&type=style&index=0&id=5990ab41&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5990ab41",
  null
  
)

export default component.exports